/** @jsxImportSource @emotion/react */
"use client";

import Box from "@mui/material/Box";
import { PortableText, PortableTextComponents } from "@portabletext/react";
import Typography from "@mui/material/Typography";

import { portableTextBox } from "./styles";

type BlogContentProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  content: any;
};

const components: PortableTextComponents = {
  block: {
    normal: ({ children }) => (
      <Typography variant="body1" lineHeight={1.8}>
        {children}
      </Typography>
    ),
  },
  list: {
    bullet: ({ children }) => (
      <Box component="ul" sx={{ pl: 4, my: 2 }}>
        {children}
      </Box>
    ),
    number: ({ children }) => (
      <Box component="ol" sx={{ pl: 4, my: 2 }}>
        {children}
      </Box>
    ),
  },
  listItem: {
    bullet: ({ children }) => (
      <Box component="li" sx={{ mb: 1 }}>
        {children}
      </Box>
    ),
    number: ({ children }) => (
      <Box component="li" sx={{ mb: 1 }}>
        {children}
      </Box>
    ),
  },
};

export const BlogContent = ({ content }: BlogContentProps) => {
  return (
    <Box css={portableTextBox}>
      <PortableText value={content} components={components} />
    </Box>
  );
};
